import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import SceneDashboardView from '../components/dashboard/SceneDashboardView';
import CompPreviewBox from '../components/dashboard/CompPreviewBox';
import AiCameraAlertOverlay from '../components/dashboard/AiCameraAlertOverlay';
import useDashboardStore from '../stores/dashboardStore';
import { fetchPage } from '../api/pages';
import Watermark, { useWatermarkFlag } from '../components/Watermark';
import { useViewerDataLink } from '../hooks/useViewerDataLink';

/** 大屏发布页：无工具栏纯渲染 + 自适应全屏 + 数据源按 refreshInterval 自动刷新 */
export default function DashboardPublish() {
  const { id } = useParams();
  const { currentPage, components, setPage } = useDashboardStore();
  const [loading, setLoading] = useState(true);
  const [scaleX, setScaleX] = useState(1);
  const [scaleY, setScaleY] = useState(1);
  /** D-06：免费/基础发布带水印；专业/企业去水印 */
  const withWatermark = useWatermarkFlag();
  // DW-P0-5：发布态数据链路（3D 底场景绑定/设备动画/构件数据），与 Viewer 同源
  useViewerDataLink(currentPage?.sceneId ?? null);

  useEffect(() => {
    if (id) {
      fetchPage(id)
        .then((page) => setPage(page as any))
        .catch(() => {})
        .finally(() => setLoading(false));
    }
  }, [id, setPage]);

  const pw = currentPage?.config?.width || 1920;
  const ph = currentPage?.config?.height || 1080;

  // 画布完全填满真实大屏屏幕（scaleX=screen.width/pw, scaleY=screen.height/ph 独立拉伸），
  // 组件贴边、无空隙、不越界，与编辑器/预览行为一致
  useEffect(() => {
    const fit = () => {
      setScaleX(screen.width / pw);
      setScaleY(screen.height / ph);
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, [pw, ph]);

  const fullscreenStyle: React.CSSProperties = {
    position: 'fixed', inset: 0, zIndex: 9999,
    background: currentPage?.config?.backgroundColor || '#0a0a1a',
    overflow: 'hidden',
  };

  return (
    <div style={fullscreenStyle}>
      {loading ? null : currentPage?.sceneId ? (
        <SceneDashboardView
          sceneId={currentPage.sceneId}
          components={components}
          pageWidth={pw}
          pageHeight={ph}
          backgroundColor={currentPage?.config?.backgroundColor}
          backgroundImage={currentPage?.config?.backgroundImage}
          show3D
        />
      ) : (
        <div style={{ width: pw * scaleX, height: ph * scaleY, position: 'relative', flexShrink: 0 }}>
          <div style={{ position: 'relative', width: pw, height: ph, transform: `scale(${scaleX}, ${scaleY})`, transformOrigin: 'top left' }}>
            {components.map((comp) => (
              <CompPreviewBox key={comp.id} comp={comp} />
            ))}
          </div>
        </div>
      )}
      {/* D-06：发布层水印（免费/基础） */}
        <Watermark show={withWatermark === true} />

      {/* M3-M7：AI 检测告警画中画（无论是否关联 3D 场景均生效） */}
      <AiCameraAlertOverlay />
    </div>
  );
}
